module.exports = __webpack_public_path__ + "img/6-4.e11248e0.jpg";